<template>
  <div :class="$style.wrapper" :style="{ backgroundColor: itemData[type].color }">
    {{ itemData[type].label }}
  </div>
</template>

<script setup lang="ts">
defineProps({
  type: {
    type: String,
    required: true,
  },
});

interface ItemData {
  [key: string]: {
    label: string;
    color: string;
  };
}

const itemData: ItemData = {
  CONSUMABLE: {
    label: "Consumable",
    color: "var(--vd-color-indigo-500)",
  },
  NON_CONSUMABLE: {
    label: "Non-Consumable",
    color: "var(--vd-color-teal-500)",
  },
  CURRENCY: {
    label: "Currency",
    color: "var(--vd-color-yellow-500)",
  },
};
</script>

<style module lang="scss">
.wrapper {
  padding: 5px 8px;
  border-radius: 4px;
  font-size: 10px;
  width: fit-content;
  color: white;
  font-weight: 600;
  white-space: nowrap;
}
</style>
